import { render, staticRenderFns } from "./job-form-titles-description.vue?vue&type=template&id=939e00ca&scoped=true"
import script from "./job-form-titles-description.vue?vue&type=script&lang=js"
export * from "./job-form-titles-description.vue?vue&type=script&lang=js"
import style0 from "./job-form-titles-description.vue?vue&type=style&index=0&id=939e00ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939e00ca",
  null
  
)

export default component.exports